import classNames from 'classnames';

interface SelectedCounterProps {
  className?: string;
  counter: number;
}

export function SelectedCounter({ className, counter }: SelectedCounterProps) {
  return (
    <div className={classNames(className, 'text-slate-500 text-xs')}>
      {counter} {counter === 1 ? 'day' : 'days'} selected in total
    </div>
  );
}
